import { type SearchResultProps } from '@atlassian/search-dialog';
import { useCallback } from 'react';
import {
	onAdvancedSearchSelected,
	type AdvancedSearchAnalyticsProps,
	useAnalytics,
	getTrigger,
	isNewTab,
} from '../../common/analytics';

export interface SearchResultAnalyticsCallbacks {
	onHighlightCallback: () => void;
	onSelectCallback: (e: React.MouseEvent<Element, MouseEvent> | KeyboardEvent) => void;
	onContextMenuCallback: (e: React.MouseEvent<Element, MouseEvent> | KeyboardEvent) => void;
}

type Props = Pick<SearchResultProps, 'onHighlighted' | 'onSelect'> &
	Pick<AdvancedSearchAnalyticsProps, 'actionSubjectId'>;
/**
 * Returns callbacks which fire analytic events which should be triggered
 * when interacting with advanced search links
 *
 * Currently no events are fired for highlight and context menu click
 */
export const useAdvancedSearchAnalyticsCallbacks = ({
	onSelect,
	onHighlighted,
	actionSubjectId,
}: Props): SearchResultAnalyticsCallbacks => {
	const { fireAnalyticsEvent } = useAnalytics();

	const onHighlightCallback = useCallback(() => {
		onHighlighted?.();
	}, [onHighlighted]);

	const onSelectCallback = useCallback(
		(e: React.MouseEvent<Element, MouseEvent> | KeyboardEvent) => {
			fireAnalyticsEvent(
				onAdvancedSearchSelected({
					actionSubjectId: actionSubjectId,
					trigger: getTrigger(e),
					isLoading: false,
					newTab: isNewTab(e),
				}),
			);

			onSelect?.(e);
		},
		[fireAnalyticsEvent, actionSubjectId, onSelect],
	);

	const onContextMenuCallback = useCallback(() => {}, []);

	return {
		onHighlightCallback,
		onSelectCallback,
		onContextMenuCallback,
	};
};
